<script setup lang="ts">
import { AppMarkdownWrapper, AppFlicker } from '@libs/ui';

interface ActivityDetailsMainProps {
  mainDescription: string | undefined;
}
const props = defineProps<ActivityDetailsMainProps>();
</script>

<template>
  <AppMarkdownWrapper
    v-if="props.mainDescription"
    :source="props.mainDescription"
  />

  <AppFlicker
    v-else
    width="100%"
    height="100%"
    border-radius="border-radius-12"
  />
</template>
